module.exports = __webpack_public_path__ + "img/logo-white.92a3e92c.png";